import { formatDate } from "../models/MetricOperations";
import { trendlineData } from "../types";

export function getRoundOffTimeKey(timestamp: number, granularity: string) {
  const timeZoneOffset = 19800000; // to offset time by 5:30 hours
  const dateInIST = new Date(timestamp - timeZoneOffset);
  if (granularity === "1 hour") {
    return dateInIST.getHours() + 1;
  } else {
    dateInIST.setHours(0, 0, 0);
    return dateInIST.getTime();
  }
}

export function getTimeRoundOffData(data: any[], granularity: string): trendlineData {
  const lineDataPoints: Array<{ x: number; y: number; formatted: string }> = [];
  if (!Array.isArray(data)) {
    console.error("getTimeRoundOffData: expected array, received", typeof data, data);
    return lineDataPoints;
  }
  data.forEach(({ x, y }) => {
    const timeKey = getRoundOffTimeKey(x, granularity);
    lineDataPoints.push({
      x: timeKey,
      y,
      formatted: formatDate(x, granularity),
    });
  });

  return lineDataPoints;
}
